<template>
    <div>
        <div v-show="!googleCalendarEvents.length">
            <button class="btn btn-primary btn-raised" @click="loadEvents">
                {{ $t("meetings.linkGoogleCalendarEvent") }}
                <i
                    v-show="loadingGoogleCalendarEvents"
                    class="fal fa-spinner fa-spin l-default-margin-s"
                ></i>
            </button>
        </div>
        <div v-show="googleCalendarEvents && googleCalendarEvents.length" class="row">
            <div class="col-md-6">
                <l-input-typeahead
                    :show-picture="false"
                    :show-checkbox="false"
                    style="margin-top: 0px;"
                    :label="``"
                    :placeholder="$t(`surveys.details.placeholderFilter`)"
                    :data="
                        googleCalendarEvents.map(e => {
                            e.name = e.summary;
                            return e;
                        })
                    "
                    :template-type="'CalendarEvent'"
                    :on-select="event => select(event)"
                    :on-input-change="() => {}"
                    :max-matches="200"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import LInputTypeahead from "@/components/LInputTypeahead";

export default {
    components: {
        LInputTypeahead,
    },
    props: {
        onSelect: {
            required: true,
            type: Function,
        },
        onError: {
            required: true,
            type: Function,
        },
    },
    data() {
        return {
            loadingGoogleCalendarEvents: false,
        };
    },
    computed: {
        ...mapGetters({
            googleCalendarEvents: "googleCalendar/calendar/events",
        }),
    },
    methods: {
        async loadEvents() {
            this.loadingGoogleCalendarEvents = true;

            try {
                await this.$store.dispatch("googleCalendar/calendar/getEvents");
            } catch {
                this.onError(new Error("Failed to fetch events"));
            } finally {
                this.loadingGoogleCalendarEvents = false;

                if (!this.googleCalendarEvents || !this.googleCalendarEvents.length) {
                    this.onError(new Error("No events found"));
                } else {
                    this.$refs.gCalEventDropdown?.show();
                }
            }
        },
        async select(event) {
            this.onSelect(event);
            // we don't want to cache the events here
            await this.$store.dispatch("googleCalendar/calendar/clearEvents");
        },
    },
};
</script>

<style scoped></style>
